<div class="breadcrumb-area">
	<h1>Cajas</h1>
</div>
<div class="card mb-5">
	<div class="card-header">
		<h3>Administración de Cajas <a (click)="createAndSave()"><i
					class="a-hover fa fa-plus"></i></a></h3>
	</div>
	<div class="card-body">
		<p class="text-muted">Una caja se encuentra activa si el icono <i class="fa fa-power-off"></i> se encuentra
			en color <span style="font-weight: 900;color: green;">verde</span>. Activa o desactiva la caja dando
			click sobre el icono antes mencionado.</p>
		<div class="row">
			<div class="col-sm-4 new-family" *ngIf="creating">
				<h4 id="pin-container">Crea una caja<i (click)="alwaysCreating=!alwaysCreating"
						[class.opacity-20]="!alwaysCreating" class="fa fa-thumbtack"></i></h4>
				<span>Datos de la caja</span>
			</div>
			<div [ngClass]="creating?'col-sm-8':'col'">
				<div class="table table-responsive">
					<table class="table">
						<thead>
							<tr>
								<th class="ta">
									Estado
								</th>
								<th>
									Alias
								</th>
								<th>
									Encargado
								</th>
								<th>
									Bodega
								</th>
								<th class="ta">
									Balance GTQ
								</th>
								<th class="ta">
									Balance USD
								</th>
								<th class="ta">
									Opción
								</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let cashier of cashiers">
								<tr>
									<td class="ta">
										<i (click)="activeOrInactive(cashier)" class="status-category fa fa-power-off"
											[class.active-category]="cashier.active"></i>
									</td>
									<td>
										<ng-container *ngIf="editing!=cashier.id">
											{{cashier.name}}
										</ng-container>
										<div class="input-group input-group-sm" *ngIf="editing==cashier.id">
											<input type="text" name="name-editing-family" [(ngModel)]="cashier.name"
												id="name-editing-family" class="form-control">
										</div>
									</td>
									<td>
										<ng-container *ngIf="editing!=cashier.id">
											<span *ngIf="cashier.manager">
												{{getUserName(cashier.manager)}}
											</span>
											<span *ngIf="!cashier.manager" class="opacity-30">
												<i class="fa fa-circle-info"></i> Desconocido.
											</span>
										</ng-container>
										<div class="input-group input-group-sm" *ngIf="editing==cashier.id">
											<textarea name="description-editing-family" [(ngModel)]="cashier.manager"
												id="description-editing-family" class="form-control"></textarea>
										</div>
									</td>
									<td class="ta">
										<span *ngIf="cashier.warehouse">
											{{warehouses[cashier.warehouse].name}}
										</span>
										<p class="text-muted opacity-30" *ngIf="!cashier.warehouse">
											<i class="fa fa-circle-info"></i> Sin bodega asignada
										</p>
									</td>
									<td class="ta">
										{{cashier.amount | currency: 'Q'}}
									</td>
									<td class="ta">
										{{cashier.amountForeign | currency: '$'}}
									</td>
									<td class="ta">
										<span class="a-hover" (click)="editAndSave(cashier)"><i
												class="fa fa-edit"></i></span>
									</td>
								</tr>
							</ng-container>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>
<app-modal-cashier *ngIf="editing || creating" [newCashier]="newCashier" [isCreating]="creating" (close)="closeModal($event)"></app-modal-cashier>